var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 14.8688L14.8688 16L11.4744 12.6064L12.6056 11.4744L16 14.8688ZM6.4 11.2C3.7536 11.2 1.6 9.0472 1.6 6.4C1.6 3.7536 3.7536 1.6 6.4 1.6C9.0464 1.6 11.2 3.7536 11.2 6.4C11.2 9.0472 9.0464 11.2 6.4 11.2ZM6.4 0C2.8656 0 0 2.8656 0 6.4C0 9.9344 2.8656 12.8 6.4 12.8C9.9344 12.8 12.8 9.9344 12.8 6.4C12.8 2.8656 9.9344 0 6.4 0Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGreen);
export default __webpack_public_path__ + "static/media/search-green.71fb3e130bc2bec1607a3ff40ca18f74.svg";
export { ForwardRef as ReactComponent };